var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8545 6.65152L7.34452 0.141523C7.15452 -0.0484766 6.85452 -0.0484766 6.66452 0.141523L0.154522 6.65152C-0.145478 6.95152 0.0645222 7.47152 0.494522 7.47152H1.53452V13.0015C1.53452 13.5515 1.98452 14.0015 2.53452 14.0015H4.99452V12.0015C4.99452 11.4515 5.44452 11.0015 5.99452 11.0015H7.99452C8.54452 11.0015 8.99452 11.4515 8.99452 12.0015V14.0015H11.4445C11.9945 14.0015 12.4445 13.5515 12.4445 13.0015V7.47152H13.5045C13.9345 7.47152 14.1445 6.95152 13.8445 6.65152H13.8545Z",
    fill: "url(#paint0_linear_25084_66366)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25084_66366",
    x1: 9.42096,
    y1: 14.0015,
    x2: 4.55901,
    y2: 0.00564936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE3876",
    stopOpacity: 0.519832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D030DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.ff1d868c922dcbe3c8851d17a616b55b.svg";
export { ForwardRef as ReactComponent };